import { Outlet } from 'react-router-dom';
import { FolderOpen, Settings, Users } from 'lucide-react';
import { SimpleProjectSelector } from 'src/components/SimpleProjectSelector';
import { UserMenu } from 'src/components/UserMenu';
import { ORG_OWNER_ROLE, useGetMyInfoQuery } from 'src/hooks/useGetMyInfoQuery';
import { useIsOrgIdEqualProjectOrgId } from 'src/hooks/useIsOrgIdEqualProjectOrgId';

import { SidebarLayout } from '../SidebarLayout';

// This is a sidebar layout for the organization settings page
const HomeSidebar = () => {
  // check if the org id is equal to the project org id
  useIsOrgIdEqualProjectOrgId(); // log error if org id is not equal to project org id

  const { data: myInfo } = useGetMyInfoQuery();
  const isOrgOwner = myInfo?.orgRole?.role === ORG_OWNER_ROLE;

  return (
    <SidebarLayout.Sidebar>
      {/* Sidebar content goes here */}
      <SidebarLayout.SidebarHeader>
        <SimpleProjectSelector />
      </SidebarLayout.SidebarHeader>
      <SidebarLayout.SidebarMain>
        {/* Home navigation items */}
        <SidebarLayout.SidebarMainLayout.ListNavLink
          to="/home/projects"
          label="Projects"
          iconSvg={<FolderOpen size={20} />}
        />

        {/* Organization section - only show if user is org owner */}
        {isOrgOwner && (
          <>
            <SidebarLayout.SidebarMainLayout.ListNavLink
              to="/home/org-settings"
              label="Org settings"
              iconSvg={<Settings size={20} />}
            />
            <SidebarLayout.SidebarMainLayout.ListNavLink
              to="/home/org-users"
              label="Users"
              iconSvg={<Users size={20} />}
            />
          </>
        )}

        {/* Push user menu to bottom */}
        <div style={{ flex: '1' }} />
        <UserMenu />
      </SidebarLayout.SidebarMain>
    </SidebarLayout.Sidebar>
  );
};

export const SidebarHomeLayout = () => (
  <SidebarLayout.LayoutContainer>
    <HomeSidebar />
    {/* Main page content goes here */}
    <SidebarLayout.MainPage>
      <Outlet />
    </SidebarLayout.MainPage>
  </SidebarLayout.LayoutContainer>
);
